import compact from 'lodash/compact';
import Catalyst from '@Services/Catalyst';

const routesMap = {
  'main.search.quick.results': 'preview',
};

// eslint-disable-next-line import/prefer-default-export
export function trackFindPreparations({ state, substanceId, context }) {
  const trackedObj = {
    criteria: `Manually synthesize:${substanceId}`,
    type: compact([Catalyst.getPrefix(), 'explicit', routesMap[state] || 'results', context, 'Manual']).join(':'),
  };

  Catalyst.setSearchResults(trackedObj, true);
}
